import { CutoffCountdownDuration } from "./useCutoffCountdown";

export const CutoffCountdown = ({
  timeLeft,
  className,
  format = "H[h] mm[m] ss[s]",
}: {
  timeLeft: CutoffCountdownDuration;
  className?: string;
  format?: string;
}) => <span className={className}>{timeLeft.format(format)}</span>;
